import { TypographyProps as MaterialTypographyProps } from '@mui/material';
import { useMemo } from 'react';
import { TypographyVariants, Variant } from '../typography.types';

interface UseTypographyParams {
  variant?: Variant;
}

export const useTypography = ({ variant }: UseTypographyParams) => {
  const materialEquivalentVariant = useMemo<MaterialTypographyProps['variant']>(() => {
    switch (variant) {
      case TypographyVariants.H1_SEMIBOLD:
        return 'h1';
      case TypographyVariants.H2_SEMIBOLD:
        return 'h2';
      case TypographyVariants.H3_SEMIBOLD:
        return 'h3';
      case TypographyVariants.H4_SEMIBOLD:
        return 'h4';
      case TypographyVariants.H5_SEMIBOLD:
        return 'h5';
      case TypographyVariants.H6_SEMIBOLD:
        return 'h6';
      case TypographyVariants.H7_SEMIBOLD:
        return 'h6';
      case TypographyVariants.H8_MEDIUM:
      case TypographyVariants.H8_SEMIBOLD:
      case TypographyVariants.H8_5_REGULAR:
        return 'subtitle1';
      case TypographyVariants.BODY1_LIGHT:
      case TypographyVariants.BODY1_5_LIGHT:
      case TypographyVariants.BODY1_REGULAR:
      case TypographyVariants.BODY1_5_REGULAR:
      case TypographyVariants.BODY1_MEDIUM:
      case TypographyVariants.BODY1_5_MEDIUM:
      case TypographyVariants.BODY1_SEMIBOLD:
        return 'body1';
      case TypographyVariants.BODY2_LIGHT:
      case TypographyVariants.BODY2_5_LIGHT:
      case TypographyVariants.BODY2_REGULAR:
      case TypographyVariants.BODY2_5_REGULAR:
      case TypographyVariants.BODY2_MEDIUM:
      case TypographyVariants.BODY2_5_MEDIUM:
      case TypographyVariants.BODY2_SEMIBOLD:
        return 'body2';
      case TypographyVariants.BODY3_REGULAR:
      case TypographyVariants.BODY3_5_REGULAR:
      case TypographyVariants.BODY3_MEDIUM:
      case TypographyVariants.BODY3_5_MEDIUM:
      case TypographyVariants.BODY3_SEMIBOLD:
        return 'body2';
      case TypographyVariants.OVERLINE1_REGULAR:
        return 'overline';
      default:
        return 'body1';
    }
  }, [variant]);

  return {
    materialEquivalentVariant,
  };
};
